import { Component, ElementRef, OnDestroy, ViewContainerRef } from '@angular/core';
import { Overlay, OverlayRef, ConnectedPosition } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ItemSpecTooltipComponent } from 'src/app/shared/components/ag-grid/item-spec-tooltip/item-spec-tooltip.component';

const POPOVER_POSITIONS: ConnectedPosition[] = [
  { originX: 'end', originY: 'top', overlayX: 'start', overlayY: 'top', offsetX: 8 },
  { originX: 'start', originY: 'top', overlayX: 'end', overlayY: 'top', offsetX: -8 },
];

@Component({
  selector: 'app-description-cell',
  standalone: true,
  template: `
    <div class="description-cell" (click)="toggleSpecPopover()">
      <span>{{ desc }}</span>
      @if (mfgPart) {
        <span class="text-muted small">MFG Part Number: {{ mfgPart }}</span>
      }
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }
      .description-cell {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        cursor: pointer;
      }
    `,
  ],
})
export class DescriptionCellComponent implements ICellRendererAngularComp, OnDestroy {
  desc = '';
  mfgPart = '';

  private rowData: any;
  private overlayRef: OverlayRef | null = null;

  constructor(
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private elementRef: ElementRef<HTMLElement>,
  ) {}

  agInit(params: ICellRendererParams): void {
    this.rowData = params.data;
    this.desc = params.data?.desc1 || '';
    this.mfgPart = params.data?.mfg_part_number || '';
  }

  refresh(): boolean {
    return false;
  }

  toggleSpecPopover(): void {
    if (this.overlayRef) {
      this.closeSpecPopover();
      return;
    }
    if (!this.rowData) return;

    const overlayRef = this.overlay.create({
      positionStrategy: this.overlay
        .position()
        .flexibleConnectedTo(this.elementRef)
        .withPositions(POPOVER_POSITIONS)
        .withPush(true),
      scrollStrategy: this.overlay.scrollStrategies.close(),
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
    });
    overlayRef.backdropClick().subscribe(() => this.closeSpecPopover());

    const portal = new ComponentPortal(ItemSpecTooltipComponent, this.viewContainerRef);
    const componentRef = overlayRef.attach(portal);
    componentRef.instance.agInit({ data: this.rowData } as any);

    this.overlayRef = overlayRef;
  }

  private closeSpecPopover(): void {
    this.overlayRef?.dispose();
    this.overlayRef = null;
  }

  ngOnDestroy(): void {
    this.closeSpecPopover();
  }
}
